import { Templates } from '@Assets/SvgIcons/Templates';
import { RouteEnums } from '@Helper/Enums';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import FileActionMenu from '../FileActionMenu/FileActionMenu.component';
import { FileItemProps } from '../FileItem/FileItem.component';
import './FileCardItem.component.scss';

type FileIcons = {
  file: JSX.Element;
  folder: JSX.Element;
};

const FileIcon = (type: string = 'file'): JSX.Element => {
  const fileIcons: FileIcons = {
    file: <Templates color={'#9997AF'} width={'75'} height={'60'} />,
    folder: (
      <FolderOutlinedIcon style={{ fontSize: '57.604px', color: '#9997AF' }} />
    ),
  };
  return fileIcons[type as keyof FileIcons];
};

const getFolderInfo = (file: FileItemProps) => {
  const counts: any = {
    file: 0,
    folder: 0,
  };
  const { files = [] } = file;
  files.forEach(({ type = 'file' }) => {
    counts[type] += 1;
  });
  return (
    <div className="file-card-item__body__desc">
      Folders: {counts['folder']}, Files: {counts['file']}
    </div>
  );
};

const FileCardItem = (file: FileItemProps) => {
  const {
    name,
    htmlName,
    description,
    type = 'file',
    createdAt,
    updatedAt,
    handleOnPathClicked,
    actionMenuItems,
    onActionMenuItemClick,
  } = file;

  const isFolder = type !== 'file';
  const navigate = useNavigate();

  const onPathClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!isFolder) {
      handleOnFileClicked(file);
    }

    handleOnPathClicked(file);
  };

  const handleActionClick = (action: string) => {
    onActionMenuItemClick && onActionMenuItemClick(file, action);
  };

  const handleOnFileClicked = (file: FileItemProps) => {
    navigate(RouteEnums.PersonalTemplatesDetail + file.id);
  };

  const getFormattedDate = (date: string) => {
    const dateTime = new Date(date);
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };
    return new Intl.DateTimeFormat('en-US', options).format(dateTime);
  };

  const filteredActionMenuItems = actionMenuItems.filter(
    ({ hideOn = [] }) => !hideOn.includes(type)
  );

  return (
    <div className="file-card-item">
      <div
        className={`file-card-item__head type-${type}`}
        data-testid={`file-card-item__${name?.replace(/ /g, '_')}`}
        onClick={onPathClick}
      >
        {FileIcon(type)}
      </div>
      <div className="file-card-item__body">
        <div className="file-card-item__body__title">
          <span dangerouslySetInnerHTML={{ __html: htmlName ?? name ?? '' }} />
          <FileActionMenu
            icon={
              <MoreHorizOutlinedIcon
                style={{ fontSize: '20px', color: '#7D7A9A' }}
              />
            }
            items={filteredActionMenuItems}
            handleActionClick={handleActionClick}
          />
        </div>
        {isFolder && getFolderInfo(file)}
        {!isFolder && description && (
          <div className="file-card-item__body__desc">{description}</div>
        )}
        {(createdAt || updatedAt) && (
          <div className="file-card-item__body__desc">
            Last saved: {getFormattedDate(updatedAt ?? createdAt ?? '')}
          </div>
        )}
      </div>
    </div>
  );
};

export default FileCardItem;
